import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Row, Col } from "react-bootstrap";
import {
  Link,
  ThumbnailBig,
  ThumbnailDiamond,
  FooterSection,
  LinkImage,
} from "@components";
import { ChevronRight } from "@icons";
import { useHistory } from "react-router-dom";
import { NewsBannerAPI, NewsLimitAPI } from "@api";

import Image9 from "../../assets/images/image9.png";
import Image14 from "../../assets/images/image14.png";
import Image15 from "../../assets/images/image15.png";
import "./NewUpdates.scss";
import { useTranslation } from "react-i18next";
import moment from "moment";

const InvestorContainer = styled.div`
  padding-top: 56px;
  overflow: hidden;

  @media screen and (min-width: 767px) and (max-width: 991px) {
    padding-top: 0;
  }

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`;

const NewUpdates = function () {
  const { t } = useTranslation();
  const history = useHistory();
  const newsPage = (path) => {
    history.push(path);
  };

  const [newsBanner, setNewsBanner] = useState(null);
  const [announcement, setAnnouncement] = useState(null);
  useEffect(() => {
    const loadData = async () => {
      const { data } = await NewsBannerAPI();
      setNewsBanner(data.data);
    };

    const loadAnnouncementData = async () => {
      const { data } = await NewsLimitAPI({
        loc: "pengumuman",
        page: 1,
        limit: 4,
      });
      setAnnouncement(data.data.result);
    };

    if (!newsBanner) {
      loadData();
    }

    if (!announcement) {
      loadAnnouncementData();
    }
  }, [newsBanner, announcement]); 
  return (
    <InvestorContainer>
      <Row xs="12">
        <ThumbnailBig
          title={newsBanner !== null ? newsBanner[0].title : ""}
          desc={newsBanner !== null ? newsBanner[0].description : ""}
          img={newsBanner !== null ? newsBanner[0].mainBanner : ""}
        />
      </Row>
      <div className="news-update-page">
        <div className="news-update-page-content-top">
          <Row className="">
            <Col xs={12} md={6} onClick={() => newsPage("/currency-info")}>
              <LinkImage
                image={newsBanner !== null ? newsBanner[0].kurs : Image14}
                label={newsBanner !== null ? newsBanner[0].subTitle1 : t("kurs")}                
              />
            </Col>
            <Col xs={12} md={6} onClick={() => newsPage("/sbdk")}>
              <LinkImage
                image={newsBanner !== null ? newsBanner[0].sbdk : Image15}
                label={newsBanner !== null ? newsBanner[0].subTitle2 : t("sbdk")}                
              />
            </Col>
          </Row>
        </div>
        <div className="news-update-page-content-middle">
          <Row className="">
            <Col xs="12" md="6">
              <ThumbnailDiamond
                image={newsBanner !== null ? newsBanner[0].subBanner1 : Image9}
              />
            </Col>
            <Col xs="12" md="6">
              <div>
                <div
                  className="d-flex bd-highlight align-items-center py-2"
                  style={{ borderBottom: "#EDEEEE thin solid" }}
                >
                  <div
                    className="d-flex text-start w-100 bd-highlight"
                    style={{ fontSize: "1.5em", fontWeight: "600" }}
                  >
                    Newsroom
                  </div>
                </div>
                <div>
                  <Link
                    href="/press-conference"
                    title={t("press_releases_and_announcements")}
                    icon={ChevronRight}
                  />
                  <Link href="/news" title={t("berita")} icon={ChevronRight} />
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <div className="news-update-page-content-bottom">
          <Row className="">
            <Col xs="12" md="6">
              <div>
                <div
                  className="d-flex bd-highlight align-items-center py-2"
                  style={{ borderBottom: "#EDEEEE thin solid" }}
                >
                  <div
                    className="d-flex text-start w-100 bd-highlight"
                    style={{ fontSize: "1.5em", fontWeight: "600" }}
                  >
                    {t("pengumuman")}
                  </div>
                  <a
                    href="/announcement"
                    className="p-2 flex-shrink-1 bd-highlight"
                    style={{
                      color: "#F2A900",
                      fontWeight: "600",
                      textDecoration: "none",
                    }}
                  >
                    {t("more")}
                  </a>
                </div>
                <div>
                  {announcement
                    ? announcement.map((item, index) => {
                        return (
                          <Link
                            key={index}
                            href={`article-detail/` + item.slug}
                            label={moment(
                              item.created_at,
                              "DD-MM-YYYY hh:mm:ss"
                            ).format("YYYY")}
                            title={item.title}
                            icon={ChevronRight}
                          />
                        );
                      })
                    : ""}
                </div>
              </div>
            </Col>
            <Col xs="12" md="6">
              <ThumbnailDiamond
                image={newsBanner !== null ? newsBanner[0].subBanner2 : Image9}
              />
            </Col>
          </Row>
        </div>
      </div>
      <FooterSection currentPage={t("new_info")} />
    </InvestorContainer>
  );
};

export default NewUpdates;
